// clipboard.service.ts

import { Injectable } from '@angular/core';
import { INotesComponent } from '@modeso/types__aumico-lib-annualreport-be';
import { ComponentType } from '@modeso/types__aumico-lib-notes-be';
import { cloneDeep } from 'lodash-es';
import { catchError, defer, from, map, Observable, of } from 'rxjs';
import { AumicoClipboardData } from '../interfaces/aumico-clipboard-data.interface';
import {
    buildClipboardEnvelope,
    looksLikeAumicoClipboard,
    migrateIfNeeded,
    serializeEnvelope,
} from '../utils/aumico-clipboard.util';

@Injectable({ providedIn: 'root' })
export class AumicoClipboardService {
    /** Write our envelope into the OS clipboard as text/plain */
    async copyComponentToClipboard(componentType: ComponentType, data: INotesComponent): Promise<void> {
        const payload: INotesComponent = cloneDeep<INotesComponent>(data);

        const envelope = buildClipboardEnvelope(componentType, payload);
        const text = serializeEnvelope(envelope);

        await navigator.clipboard.writeText(text);
    }

    /** Try to read the OS clipboard (must be called in a user gesture) */
    tryReadAumicoClipboard$(): Observable<AumicoClipboardData | null> {
        return defer(() => from(navigator.clipboard.readText())).pipe(
            map((text) => {
                if (!text) return null;
                let parsed: unknown;
                try {
                    parsed = JSON.parse(text);
                } catch {
                    return null;
                }
                if (!looksLikeAumicoClipboard(parsed)) return null;
                return migrateIfNeeded(parsed as AumicoClipboardData);
            }),
            catchError(() => of(null)),
        );
    }
}
